import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServicesPage.css';
import Breadcrumbs from '../components/Breadcrumbs';
import LiveSound1 from '../assets/Services/LiveSound.png';

const LiveSoundPage = () => (
  <div className="service-page">
    <Breadcrumbs />
    <h1>Live Sound & Events</h1>

    <div className="service-content">
      <div className="service-image-wrapper">
        <img
          src={LiveSound1}
          alt="Live Sound Setup"
          className="service-image"
        />
      </div>

      <div className="service-description">
        <p>
          Whether you're the main act at a local showcase, hosting a private party, or putting on a full-scale concert, our Live Sound &amp; Events team brings the experience and gear to keep everything running smoothly and sounding great.
        </p>

        <p>
          Need equipment? Explore our <Link to="/services/live-sound/gear-rental">PA &amp; Gear Rental</Link> options.
        </p>

        <p>
          Need someone to run sound? Our experienced <Link to="/services/live-sound/audio-engineer">Audio Engineers</Link> are available.
        </p>

        <h2 className="service-section-heading">Available Services</h2>
        <ul className="service-list">
          <li>Complete PA system rental</li>
          <li>On-site audio engineering for live shows and events</li>
          <li>Setup and breakdown of PA rental with an audio engineer</li>
          <li>Live event mobile recording</li>
        </ul>
      </div>
    </div>

    <div className="service-cta">
      <Link to="/contact" className="cta-button">
        Request a Quote
      </Link>
    </div>
  </div>
);

export default LiveSoundPage;
